import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { inWatchlist, toggleWatchlist, onWatchlistChange } from "@/lib/watchlist";

export const WatchlistButton = ({ anime, size = "sm", className = "" }) => {
  const [saved, setSaved] = useState(() => inWatchlist(anime.id));
  useEffect(() => onWatchlistChange(() => setSaved(inWatchlist(anime.id))), [anime.id]);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const added = toggleWatchlist(anime);
    toast(added ? `"${anime.title}" added to watchlist` : `"${anime.title}" removed from watchlist`);
  };

  if (size === "lg") {
    return (
      <motion.button whileTap={{ scale: 0.96 }} data-testid={`watchlist-toggle-${anime.id}`} onClick={onClick} aria-pressed={saved} data-active={saved ? "crimson" : undefined} className={`kp-btn kp-btn-ghost ${className}`}>
        <Heart size={14} className={saved ? "fill-current" : ""} /> {saved ? "In Watchlist" : "Watchlist"}
      </motion.button>
    );
  }
  return (
    <motion.button
      whileTap={{ scale: 0.85 }}
      data-testid={`watchlist-toggle-${anime.id}`}
      onClick={onClick}
      aria-pressed={saved}
      aria-label="Watchlist"
      className={`w-8 h-8 kp-glass flex items-center justify-center transition-colors ${saved ? "text-[#FF2A55]" : "text-white/80 hover:text-white"} ${className}`}
    >
      <Heart size={14} className={saved ? "fill-current" : ""} />
    </motion.button>
  );
};
